import Work1 from "../../assets/Target.png";
import Work2 from "../../assets/butterfly.png";
import Work3 from "../../assets/todo.png";
import Work4 from "../../assets/pikachu2.png";
import Work5 from "../../assets/targetwebposter.png";
import Work6 from "../../assets/Sanctuary/Desktop - 5.png";

const Menu = [
  {
    id: 1,
    image: Work1, // Replace with your actual import or image path
    title: "Target",
    category: ["React", "Frontend", "Backend", "Figma"],
    url: "https://play.google.com/store/apps/details?id=com.targetsahgal&pli=1",
    repositoryUrl: "" // Add repo URL if available
  },
  {
    id: 2,
    image: Work2, // Replace with your actual import or image path
    title: "Butterfly Real Estate Website",
    category: ["Frontend", "Figma", "Landing Page"],
    url: "", // Add live URL if available
    repositoryUrl: "" // Add repo URL if available
  },
  {
    id: 3,
    image: Work3, // Replace with your actual import or image path
    title: "ToDo App Dashboard",
    category: ["UI Design", "Figma", "Dashboard"],
    url: "", // Add live URL if available
    repositoryUrl: "" // Add repo URL if available
  },
  {
    id: 4,
    image: Work4, // Replace with your actual import or image path
    title: "Pikachu Game Website",
    category: ["UI Design", "Figma", "Website"],
    url: "", // Add live URL if available
    repositoryUrl: "" // Add repo URL if available
  },
  {
    id: 5,
    image: Work5, // Replace with your actual import or image path
    title: "Target App Landing Page",
    category: ["UI Design", "Figma", "Website"],
    url: "", // Add live URL if available
    repositoryUrl: "" // Add repo URL if available
  },
  {
    id: 6,
    image: Work6,
    title: "Sanctuary",
    category: ["React Native", "Firebase", "Backend", "Mobile"],
    url: "https://play.google.com/store/apps/details?id=com.sahgal.sanctuaryy",
    repositoryUrl: "https://github.com/AbhaySahgal/Sanctuary.git"
  },
];

export default Menu;
